/* eslint-disable @typescript-eslint/no-explicit-any */
export const stringRequired = (value: string, message: string) => {
	if (!value) {
		return message;
	}

	return undefined;
};

export const arrayIsEmpty = (arr: Array<any>, message: string) => {
	if (!arr.length) {
		return message;
	}

	return undefined;
};